import React, { useState } from "react";
import Popup from "../Modal/Popup";
import { Spin } from "antd";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { LoadingOutlined } from "@ant-design/icons";

const SaveOrCancel = ({ saved, saveAndExit, cancel, close }) => {
    const [loading, setLoading] = useState(false);
    const [loadingDiscard, setLoadingDiscard] = useState(false);

    const handleSaveAndExit = () => {
        setLoading(true);
        setTimeout(() => {
            saveAndExit();
        }, 1000);
    };

    const handleDiscard = () => {
        setLoadingDiscard(true);
        setTimeout(() => {
            cancel();
            setLoadingDiscard(false);
        }, 1500);
    };

    useEffect(() => {
        if (saved) {
            setLoading(false);
        }
    }, [saved]);

    return (
        <Popup
            width="700"
            header="Save & Exit"
            parentID="saveOrCancelItWrapper"
            close={close}
        >
            <div className="createNewDP modalContentWrapper">
                <div className="window">
                    <h3>
                        Your page contains changes that have not been saved. If
                        you close the builder without saving, these changes will
                        be lost.
                        <br />
                        If you would like to leave the builder and save all
                        changes, please select <b>Save & Exit</b>. If you would
                        like to discard all recent changes, choose{" "}
                        <b>Discard & Exit</b>.
                    </h3>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                        }}
                    >
                        <button onClick={handleSaveAndExit} className="save">
                            {loading ? (
                                <Spin
                                    indicator={<LoadingOutlined spin />}
                                    style={{ color: "white" }}
                                />
                            ) : (
                                "Save & Exit"
                            )}
                        </button>

                        <button onClick={handleDiscard} className="no">
                            {loadingDiscard ? (
                                <Spin
                                    indicator={<LoadingOutlined spin />}
                                    style={{ color: "#173151" }}
                                />
                            ) : (
                                "Discard & Exit"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default SaveOrCancel;

SaveOrCancel.propTypes = {
    saved: PropTypes.bool,
    saveAndExit: PropTypes.func,
    cancel: PropTypes.func,
    close: PropTypes.func,
};
